import { AppTableFilters } from 'services/AppTableFilters';
import { t } from 'i18next';
import { createFilter } from 'components/Tables/ColumnCreationHelper';
import { getLicenseFilterOptions, filterHasLicense } from 'utilities/FilterUtils';

export const appTableFiltersInstance = new AppTableFilters();

export const OrganizationsTableColumns = (linceseTypes : string[]) => [
  {
    id: 'id',
    Header: t('id'),
    accessor: 'id',
    filter: {
      id: 'id',
      type: 'textfields',
      onApply: ({ id }: { id: string }) => {
        if (id) {
          appTableFiltersInstance.addFilter({
            id: 'id',
            type: 'textfields',
            label: `${t('id')}: ${id}`,
            field: 'id',
            value: id,
          });
        }
      },
      inputs: [
        {
          id: 'id',
          // this is the field inside the data object that should be used to filter the data
          field: 'id',
          label: t('id'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'name',
    Header: t('name'),
    accessor: 'name',
    filter: {
      id: 'name',
      type: 'textfields',
      onApply: ({ name }: { name: string }) => {
        if (name) {
          appTableFiltersInstance.addFilter({
            id: 'name',
            type: 'textfields',
            label: `${t('name')}: ${name}`,
            field: 'name',
            value: name,
          });
        }
      },
      inputs: [
        {
          id: 'name',
          // this is the field inside the data object that should be used to filter the data
          field: 'name',
          label: t('name'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'shortName',
    Header: t('shortName'),
    accessor: 'shortName',
    maxWidth: 80,
    filter: {
      id: 'shortName',
      type: 'textfields',
      onApply: ({ shortName }: { shortName: string }) => {
        if (shortName) {
          appTableFiltersInstance.addFilter({
            id: 'shortName',
            type: 'textfields',
            label: `${t('shortName')}: ${shortName}`,
            field: 'shortName',
            value: shortName,
          });
        }
      },
      inputs: [
        {
          id: 'shortName',
          // this is the field inside the data object that should be used to filter the data
          field: 'shortName',
          label: t('shortName'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'licenses',
    Header: t('licenses'),
    accessor: 'licenses',
    maxWidth: 80,
    filter: createFilter(
      appTableFiltersInstance,
      'multioption',
      "licenses",
      'Licenses',
      getLicenseFilterOptions(linceseTypes),
      (item, value: string[]) => {
        return !!filterHasLicense(value, item);
      }),
  },
  {
    id: 'actions',
    Header: t('actions'),
  },
];